<template>
    <i v-if="iconClass" :class="iconClass"></i>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
});

const iconClass = computed(() => {
    switch (props.icon) {
        case "heart":
            return "fa-light fa-file-heart";
        case "mobile":
            return "fa-light fa-mobile-button";
        case "smile":
            return "fa-light fa-face-smile-beam";
        case "rocket":
            return "fa-light fa-rocket-launch";
        case "champagne":
            return "fa-light fa-champagne-glasses";
        case "pointer":
            return "fa-light fa-arrow-pointer";
        default:
            return null;
    }
});
</script>
